import React from 'react'
import { Drawer, Toolbar, List, ListItem, ListItemText } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import { useStyles } from './style'

export default function AppDrawer () {
  const classes = useStyles()

  return (
    <Drawer
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper
      }}
      anchor='left'
      variant='permanent'
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        <List>
          <ListItemLink to='/' primary='Home' />
          <ListItemLink to='/clients' primary='Clients' />
        </List>
      </div>
    </Drawer>
  )
}

function ListItemLink (props) {
  const classes = useStyles()
  const { primary, to } = props
  const location = useLocation()

  const isCurrentRoute = location.pathname === to

  const CustomLink = React.useMemo(() => {
    return React.forwardRef((linkProps, ref) => (
      <Link ref={ref} to={to} {...linkProps} />
    )
    )
  },
  [to]
  )

  return (

    <ListItem button component={CustomLink}>
      {/* <ListItemIcon>{icon}</ListItemIcon> */}
      <ListItemText className={isCurrentRoute ? classes.activeLink : classes.inactiveLink} primary={primary} />
    </ListItem>
  )
}
